import { memo } from 'react';
import { CashStoresPage } from './CashStoresPage';

/** Gallery entry: canonical cash-stores with the barcode drawer already expired. */
export const CashStoresBarcodeExpiredPage = memo(() => (
  <CashStoresPage preview="expired" />
));
